import * as React from 'react';

import { NEWBUILDING_COMPARE_ENABLED_CONFIG } from '../../constants/newbuildingCompare';
import { NewbuildingComparisonButton } from '../../components/NewbuildingComparisonButton';
import { useApplicationContext } from '../../utils/applicationContext';

export const NewbuildingComparisonButtonContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const [isAdded, setIsAdded] = React.useState(false);
  const isNewbuildingCompareEnabled = config.get<boolean>(NEWBUILDING_COMPARE_ENABLED_CONFIG) || false;

  const handleClick = React.useCallback(() => {
    setIsAdded(currentIsAdded => !currentIsAdded);
  }, []);

  if (!isNewbuildingCompareEnabled) {
    return null;
  }

  return <NewbuildingComparisonButton isAdded={isAdded} onClick={handleClick} />;
};
